export var makeUniqueArray = function (_a) {
    var array = _a.array, fieldName = _a.fieldName;
    var hash = {};
    array.forEach(function (item) {
        var itemValue = item[fieldName];
        hash[itemValue] = item;
    });
    return Object.values(hash);
};
